import Progress from "@client/content/controls/Progress/component";
import { ModalCloseButton } from "@common/controls/Modal/Header/Buttons";
import { useI18n } from "@common/hooks/i18n";
import * as React from "react";
import ProfileImage from "../../../../shared/Leaderboard/ProfileImage/component";
import { type Leaderboard } from "../../types";

export type MapProps = {
  item: Leaderboard.Item;
};

export type ActionProps = {
  onCloseClick?: () => void;
};
export default ({ item, onCloseClick }: ActionProps & MapProps) => {
  const i18n = useI18n();

  return (
    <div className="info_header">
      <ProfileImage item={item} size={85} />
      <div className="info">
        <span className="name">{item.displayName}</span>
        <span
          className="score"
          dangerouslySetInnerHTML={{
            __html: `${item.score === 1 ? i18n.aVote : i18n.nVotes.replace("{N}", item.score.toString())} | ${
              item.requiredScore === 1
                ? i18n.voteLeftToLevelUp
                : i18n.infoVotesLeftToLevelUp.replace("{VOTES}", item.requiredScore.toString())
            }`
          }}
        />
        <Progress height={15} m={item.score} n={item.score + item.requiredScore} />
      </div>

      <ModalCloseButton onClick={onCloseClick} />
    </div>
  );
};
